module.exports = __webpack_public_path__ + "static/6-2a63926efa7eb628c09b26e3e41c69e1.jpg";